import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import HomeMain from './pages/home-main.js';
import Page404 from './pages/page-404.js';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomeMain />} />
        {/* Cualquier otra ruta redirige / muestra la página 404 */}
        <Route path="*" element={<Page404 />} />
      </Routes>
    </Router>
  );
}

export default App;
